import React from "react";
import styled from "styled-components";
import {useNavigate, useParams} from "react-router";
import {Routes} from "constants/routes";
import {SmartForm} from "ui-kit/SmartForm";
import {Step} from "components/NewRelease/types";
import {FormContent} from "./FormContent";


export const Platform = () => {
    const navigate = useNavigate();
    const {id} = useParams()
    const onNext = () => navigate(Routes.NewRelease.replace(':step?', Step.TrackUpload));
    return (
        <SmartForm
            onSubmit={() => {}}
            initialValues={{}}>
            {() => {
                return (<>
                        <Container>
                                <StepContainer>
                                    <FormContent/>
                                </StepContainer>
                          
                        </Container>
                    </>
                );
            }}
        </SmartForm>
    );
};

const Container = styled.div`
    background-color: ${props => props.theme.palette.background.base};
    display: flex;
    flex-direction: column;
    padding: 0px 0px 0px 0px;
`;

const StepsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 18px;
    flex: 1;
`;

const StepContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    border-radius: 30px;
    background-color: ${props => props.theme.palette.background.primary};
`;
